import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/institucional/cartaservico/form_cad'


function CadastrarCartaServicoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Carta de Serviço ao Cidadão" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarCartaServicoScreen;